import React, { useEffect, useState } from 'react';
import icon from '../../../assets/shareholdersIcon.png';
import CustomSelectInput from '../../../components/CustomSelectInput/CustomSelectInput';
import CustomInput from '../../../components/CustomInputs/CustomInput';
import client from '../../../api/client';
import { Spinner } from 'flowbite-react';
import showToast from '../../../components/CustomToast/toastHelper';

interface AddBeneficiaryProps {
  onClose: () => void;
  onSuccess:()=>void
}
const AddBeneficiary = ({onClose, onSuccess}:AddBeneficiaryProps) => {
  const beneficiaryTypes = ["Bank", "Merchant", "Mobile"];
  const [type, setType] = useState(beneficiaryTypes[0]);
  const [banks, setBanks] = useState<any[]>([]);
  const [inputs, setInputs] = useState<any>({
    accountNumber: "",
    bankCode: "",
    type: beneficiaryTypes[0]
  });
  const [account, setAccount] = useState<any>();
  const [isResolving, setIsResolving] = useState<boolean>(false);
  const [resolved, setResolved] = useState<boolean>(false);

  const handleTypeChange = (selectedType: string) => {
    setType(selectedType);
    setInputs((prev: any) => ({ ...prev, type: selectedType, accountNumber: "" }));
    setResolved(false);  
  };

  const handleInputChange = (name: string, value: string) => {
    setInputs((prev: any) => ({ ...prev, [name]: value }));
    setResolved(false); 
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchBanks();
    };
    fetchData();
  }, []);

  const fetchBanks = async () => {
    try {
      const response = await client.get('/subsidiary/dashboard/banks');

      setBanks(response.data.banks);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('error getting data', err);
      }
    }
  };

  useEffect(() => {
    const { accountNumber, type } = inputs;

    const isValidAccount =
      (type === "Bank" && accountNumber.length >=10 && inputs.bankCode) ||
      (type === "Merchant" && accountNumber.length >= 1) ||
      (type === "Mobile" && accountNumber.length >= 10);

    if (isValidAccount) {
      resolveAccount();
    }
  }, [inputs.accountNumber,inputs.bankCode, inputs.type]);

  const resolveAccount = async () => {
    setIsResolving(true);

    const payload = {
      accountNumber: inputs.accountNumber,
      bankCode:type == "Bank" ? inputs.bankCode :"merchant",
      type: inputs.type,
    };

    try {
      const response = await client.post('/subsidiary/beneficiary/resolve', payload);

      setAccount(response.data.data);
      setResolved(true);
    } catch (err: any) {
      if (err?.response?.data?.message === 'Please login again') {
        sessionStorage.clear();
        window.location.href = '/';
      } else {
        console.error('error getting data', err);
      }
    } finally {
      setIsResolving(false);
    }
  };

  const addBeneficiary =async() =>{
    const bankInfo = banks.find(bank =>bank.bankCode == inputs.bankCode)
    const payload ={
        AccountName:account.accountName,
        accountNumber:inputs.accountNumber,
        countryId:1,
        type:inputs.type,
        ...(type === "Bank" && { bankId: bankInfo.id })
    }
    
    try {
        const response = await client.post('/subsidiary/beneficiary/create', payload);
        const message = response?.data?.message;
        showToast(message,"success")
        onClose()
        onSuccess()

    } catch (err: any) {
        if (err?.response?.data?.message === 'Please login again') {
            sessionStorage.clear();
            window.location.href = '/';
        } else {
            const message = err?.response?.data?.message;
            console.error('error getting data', err);            
            showToast(message, "error");
        }
    }
  }
  return (
    <div>
      <div>
        <img src={icon} className='my-3' alt="icon" />
        <div className='my-3'>
          <p className='text-xl font-bold'>Add New Beneficiary</p>
          <p className='text-sm'>Kindly fill in the information needed</p>
        </div>
      </div>

      <div className={`${type === "Bank" ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : "w-full"} my-4`}>
        <CustomSelectInput
          label='Type'
          items={beneficiaryTypes}
          name='type'
          onChange={handleTypeChange}
          value={type}
        />
        {type === "Bank" && (
          <CustomSelectInput
            label='Bank Name'
            items={banks}
            displayKey='name'
            valueKey='bankCode'
            name='bankCode'
            onChange={(selectedBankCode) => handleInputChange('bankCode', selectedBankCode)}
            value={inputs.bankCode}
          />
        )}
      </div>
      <div className='my-4'>
        <CustomInput
          label={type === "Bank" ? 'Account Number' : (type === "Merchant") ? 'Merchant Id' : 'Mobile Number'}
          name='accountNumber'
          value={inputs.accountNumber}
          onChange={(e) => handleInputChange('accountNumber', e.target.value)}
        />
      </div>

      <div className='my-4'>
        {resolved && account ? (
          <span className='text-sm text-green-600'>{account.accountName}</span>
        ) : isResolving ? (
          <div className='text-xs text-green-500'><Spinner size='sm'/> Verifying account details</div>
        ) : null}
      </div>

      <div className='flex gap-4 my-4'>
        <button className='border w-1/4 py-3 px-6 rounded-lg text-lg font-bold' onClick={onClose}>
          Cancel
        </button>
        <button
          className='border w-3/4 py-3 px-6 rounded-lg bg-custom-button-green text-lg font-bold'
        onClick={()=>addBeneficiary()}>
          Create
        </button>
      </div>
    </div>
  );
};

export default AddBeneficiary;
